import { render, staticRenderFns } from "./choiceProduct.vue?vue&type=template&id=16d65f1e&scoped=true&"
import script from "./choiceProduct.vue?vue&type=script&lang=js&"
export * from "./choiceProduct.vue?vue&type=script&lang=js&"
import style0 from "./choiceProduct.vue?vue&type=style&index=0&id=16d65f1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d65f1e",
  null
  
)

export default component.exports